export const JAPAN_COUNTRY_ID = "a032f3f0-81a8-41ac-bf04-f46e3be952a5" as const;
export const THAI_COUNTRY_ID = "d6ab9244-a663-43b3-b5ac-92064879d22b" as const;
